import React, { useState } from 'react';
import { Dropdown, Modal, Form } from 'react-bootstrap';
import { CommonCalendar } from '../../common/Calendar';
import i18n from 'i18n-js';
import moment from 'moment';

interface DataVal {
  description?: string;
  uid?: number;
  start?: string;
  end?: string;
}

const d: any = document;
const b2b = d.getElementsByClassName("is-b2b").length ? true : false ;
const memberBenefits = d.getElementsByClassName("is-member-benefits").length ? true : false ;
const changeSearchLabel = d.getElementById("search-button-label") ? true : false ;

const selectDate = async (
    dateFrom: string,
    dateTo: string,
    value: string,
    isFromDate: boolean,
    isToDate: boolean,
    selectDate: (val: string, str: string) =>void,
    setIsFromDate: (val: boolean) => void,
    setIsToDate: (val: boolean) => void
  ) => {

  if (isFromDate && dateTo && moment(value, 'YYYY-MM-DD') >  moment(dateTo, 'YYYY-MM-DD')) {
    alert("Invalid date");
    return false;
  }

  if (isFromDate) {
    await selectDate(value, 'from');
  }

  if (isToDate) {
    await selectDate(value, 'to');
  }

  setIsFromDate(false);
  setIsToDate(false);
}


const CalendarModal = (props: any) => {
  const { selectDate, show, onHide } = props;

  return (
    <Modal
      centered
      show={show}
      onHide={onHide}
      className="box-modal-calendar"
    >
      <Modal.Body>
        <div className="box-modal-calendar-inner">
          <CommonCalendar selectDate={selectDate} />
        </div>
      </Modal.Body>
    </Modal>
  );
}

const RenderCalendar = (props: any) => {
  const { selectDate, show, onHide, dateFrom, isTo, dateTo } = props;

  return (
    <div className="box-drop-calendar-inner">
      <CommonCalendar selectDate={selectDate} dateFrom={dateFrom} dateTo={dateTo} isTo={isTo} />
    </div>
  );
}

const setMoreOption = (toSearch: {moreOption: any, splice: (val1: number, val2: number)=>void}, setStateValue: (str: object) => void, val: string, isChecked: boolean) => {
  if (!isChecked) {
    const test = toSearch.moreOption.filter(function(item: string) {
      return item !== val
    });

    toSearch.moreOption = test;
  } else {
    if (!toSearch.moreOption) {
      toSearch.moreOption = [val]
    } else {
      toSearch.moreOption = toSearch.moreOption.concat([val]);
    }
  }
  setStateValue(toSearch);
}

const moreOptions = (props: any) => {
  const { isMoreOptionModal, setStateValue, toSearch } = props;

  return (
    <div className="box-more-options-inner">
      <Form.Group controlId="formHouseCheckbox">
        <Form.Check
          type="checkbox"
          label={i18n.t('house')}
          defaultChecked={toSearch.house}
          onChange={(e: any) => { setStateValue({ house: e.target.checked }) }}
        />
      </Form.Group>
      <Form.Group controlId="formFencedGardenCheckbox">
        <Form.Check
          type="checkbox"
          label={i18n.t('fencedGarden')}
          defaultChecked={toSearch.fencedGarden}
          onChange={(e: any) => { setStateValue({ fencedGarden: e.target.checked }) }}
        />
      </Form.Group>
      <Form.Group controlId="formDoNotHaveDogCheckbox">
        <Form.Check
          type="checkbox"
          label={i18n.t('noDogs')}
          defaultChecked={toSearch.noDogs}
          onChange={(e: any) => { setStateValue({ noDogs: e.target.checked }) }}
        />
      </Form.Group>
      <Form.Group controlId="formDoNotHaveBookingCheckbox">
        <Form.Check
          type="checkbox"
          label={i18n.t('noBookings')}
          defaultChecked={toSearch.noBookings}
          onChange={(e: any) => { setStateValue({ noBookings: e.target.checked }) }}
        />
      </Form.Group>
    </div>
  );
}

const getTIme = (data: any) => {
  const start = data.start.split(":");
  const end = data.end.split(":");

  return `${data.description} ${start[0]}:${start[1]} - ${end[0]}:${end[1]}`;
}

const dropdownItem = (arr: [object], key: string, setStateValue: (data: object) => void, toSearch: any, index: string) => {
  const data: DataVal = arr[parseInt(key)];

  let isSelected = toSearch[index];

  if (isSelected) {
    isSelected = toSearch[index].uid === data.uid ? 'isSelected' : null;
  } else {
    isSelected = null;
  }

  let description = data.description;

  if (index === 'time') {
    description = getTIme(data);
  }



  return (
    <Dropdown.Item className={isSelected} as="button" key={key} onClick={() => {
        toSearch[index] = data;
        setStateValue(toSearch);
        if (index === "solutions") {
          setStateValue({ time: null });
        }
      }}
    >
      <p className="head" >{description}</p>
    </Dropdown.Item>
  )
}

const SearchForm = (props: any) => {
  const { setStateValue, formDataRes, toSearch, isMoreOptionModal, user, userLoading } = props;
  const [isFromDate, setIsFromDate] = useState(false);
  const [isToDate, setIsToDate] = useState(false);
  const [isMore, setIsMore] = useState(false);

  document.addEventListener('click', (e:any) => {
    let container = '.box-dropdown-calendar';

    if (!e.target.closest(container)) {
      setIsFromDate(false);
      setIsToDate(false);
    }

    // let cMoreOption = '.box-more-options-inner';
    // if (!e.target.closest('.box-more-options')) {
    //   if (isMore && !e.target.closest(cMoreOption)) {
    //     setIsMore(false)
    //   }
    // }
  });

  return (
    <div className="box-search">
      <form onSubmit={(e: React.FormEvent) => { e.preventDefault() }}>
        <div className="box-wrapper-container">
          <ul>
            <li className="col-md-6 col-xs-12 box-wrapper">
              <input
                type="text"
                className="google-place-autocomplete box-search-field"
                name="searchTextField"
                id="search-location"
                placeholder={i18n.t('lookingFor')}
                autoComplete="off"

              />
            </li>
            <li className="col-md-6 col-xs-12 box-wrapper">
              <div className="box-dropdown-calendar col-md-6">
                <input
                  type="text"
                  placeholder={i18n.t('startDate')}
                  autoComplete="off"
                  value={props.dateFrom || ''}
                  id="fromcheckin"
                  readOnly
                  className="box-search-field"
                  onClick={()=> {
                    if (!isFromDate) {
                      setIsFromDate(true)
                      setIsToDate(false)
                      setStateValue({ isMoreOptionModal: false })
                    } else {
                      setIsFromDate(false)
                      setIsToDate(false)
                    }
                  }}
                />
                {
                  isFromDate ?
                    <RenderCalendar
                      {...props}
                      selectDate={(value: any) => {
                        selectDate(props.dateFrom, props.dateTo, value, isFromDate, isToDate, props.selectDate, setIsFromDate, setIsToDate)
                      }}
                    />
                    : null
                }
              </div>
              <div className="box-dropdown-calendar col-md-6">
                <input
                  type="text"
                  placeholder={i18n.t('endDate')}
                  autoComplete="off"
                  value={props.dateTo || '' }
                  id="tocheckin"
                  readOnly
                  className="box-search-field"
                  onClick={()=> {
                    if (!isToDate) {
                      setIsFromDate(false)
                      setIsToDate(true)
                      setStateValue({ isMoreOptionModal: false })
                    } else {
                      setIsFromDate(false)
                      setIsToDate(false)
                    }
                  }}
                />
                {
                  isToDate ?
                    <RenderCalendar
                      {...props}
                      isTo={true}
                      selectDate={(value: any) => {
                        selectDate(props.dateFrom, props.dateTo, value, isFromDate, isToDate, props.selectDate, setIsFromDate, setIsToDate)
                      }}
                    />
                    : null
                }
              </div>
            </li>
          </ul>
          {
            formDataRes && formDataRes.readMoreLink ?
              <div className="box-readmore">
                <a
                  href={formDataRes.readMoreLink}
                  className="readmore"
                  target="_blank"
                >
                  {i18n.t('readMoreAboutOurServices')}
                </a>
              </div>
              : null
          }


          {
            !b2b && !memberBenefits ?
              <ul>
                <li className="col-md-4 col-xs-12 box-wrapper">
                  <h6>{i18n.t('chooseSolution')}</h6>

                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic" className="box-drop-down">
                      <div className="box-selected">
                        <p className="head">
                          {
                            toSearch.solutions ?
                              toSearch.solutions.description : i18n.t('all')
                          }
                        </p>
                        {
                          // <p className="content">Content 1</p>
                        }
                      </div>
                      <i className="chevron down"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item className={toSearch.solutions === null ? 'isSelected' : '' } as="button" onClick={() => {
                          toSearch.solutions = null;
                          setStateValue(toSearch);
                          setStateValue({ time: null });
                        }}
                      >
                        <p className="head">{i18n.t('all')}</p>
                      </Dropdown.Item>
                      {
                        formDataRes.solutions ?
                          Object.keys(formDataRes.solutions).map((key) => dropdownItem(formDataRes.solutions, key, setStateValue, toSearch, 'solutions') )
                          :
                          null
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
                <li className="col-md-4 col-xs-12 box-wrapper">
                  <h6>{i18n.t('theSizeOfTheDog')}</h6>

                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic" className="box-drop-down">
                      <div className="box-selected">
                        <p className="head">
                          {
                            toSearch.sizes ?
                              toSearch.sizes.description : i18n.t('all')
                          }
                        </p>
                      </div>
                      <i className="chevron down"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        className={toSearch.sizes === null ? 'isSelected' : '' }
                        as="button"
                        onClick={() => {
                          toSearch.sizes = null;
                          setStateValue(toSearch);
                          setIsFromDate(false)
                          setIsToDate(false)
                        }}
                      >
                        <p className="head">{i18n.t('all')}</p>
                      </Dropdown.Item>
                      {
                        formDataRes.sizes ?
                          Object.keys(formDataRes.sizes).map((key) => dropdownItem(formDataRes.sizes, key, setStateValue, toSearch, 'sizes') )
                          :
                          null
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
                <li className="col-md-4 col-xs-12 box-wrapper">
                  <h6>{i18n.t('age')}</h6>

                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic" className="box-drop-down">
                      <div className="box-selected">
                        <p className="head">
                          {
                            toSearch.ages ?
                              toSearch.ages.description : i18n.t('all')
                          }
                        </p>
                      </div>
                      <i className="chevron down"></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        className={toSearch.ages === null ? 'isSelected' : '' }
                        as="button"
                        onClick={() => {
                          toSearch.ages = null;
                          setStateValue(toSearch);
                          setIsFromDate(false)
                          setIsToDate(false)
                        }}
                      >
                        <p className="head">{i18n.t('all')}</p>
                      </Dropdown.Item>
                      {
                        formDataRes.ages ?
                          Object.keys(formDataRes.ages).map((key) => dropdownItem(formDataRes.ages, key, setStateValue, toSearch, 'ages') )
                          :
                          null
                      }
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
                {
                  toSearch.solutions && (toSearch.solutions.priceColumn === "visitPrice" || toSearch.solutions.priceColumn === "walkPrice")  ?
                    <li className="col-md-4 col-xs-12 box-wrapper">
                      <h6>{i18n.t('chooseTime')}</h6>

                      <Dropdown>
                        <Dropdown.Toggle id="dropdown-basic" className="box-drop-down">
                          <div className="box-selected">
                            <p className="head">
                              {
                                toSearch.time ?
                                  getTIme(toSearch.time) : i18n.t('all')
                              }
                            </p>
                          </div>
                          <i className="chevron down"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            className={toSearch.time === null ? 'isSelected' : '' }
                            as="button"
                            onClick={() => {
                              toSearch.time = null;
                              setStateValue(toSearch);
                              setIsFromDate(false)
                              setIsToDate(false)
                            }}
                          >
                            <p className="head">{i18n.t('all')}</p>
                          </Dropdown.Item>
                          {
                            formDataRes.availableTimes ?
                              Object.keys(formDataRes.availableTimes).map((key) => dropdownItem(formDataRes.availableTimes, key, setStateValue, toSearch, 'time') )
                              :
                              null
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                    : null
                }
              </ul>
            : null
          }
          {
            !userLoading && !b2b && !memberBenefits?
              user ?
                <div className="col-sm-12 box-wrapper">
                  <p className="more-option" onClick={() => !isMore ? setIsMore(true) : setIsMore(false) }>{i18n.t('moreOptions')} <i className="chevron"></i></p>
                  <div className="box-more-options">
                      {
                        isMore ?
                          moreOptions(props)
                          : null
                      }
                  </div>
                </div>
                :
                <div className="col-sm-12 box-wrapper">
                  <a href="#" data-toggle="modal" data-target="#signin_form" className="more-option">{i18n.t('moreOptions')} <i className="chevron"></i></a>
                </div>
              : null
          }

          <div className="col-sm-12 box-wrapper text-align-center pt20">
            <button className="btn-round-red" id="searchbutton" onClick={() => {
              let elmnt = document.getElementById("search-result");
              elmnt.scrollIntoView();
              props.searchAction(true)
            }}>
                {
                    changeSearchLabel ?
                        d.getElementById("search-button-label").value
                    :
                        i18n.t('findDog')
                }
            </button>
          </div>
        </div>
      </form>
    </div>
  )
};

export default SearchForm;
